/* eslint-disable no-dupe-keys */
export default {
  app_config: {
    // 客户端类型
    client: {
      app: 'App',
      wechat_mini: '微信小程序'
    },
    // 标签
    tab: {
      login_setting: '登录配置',
      push_setting: '推送配置',
      payment_setting: '支付配置',
      email_setting: '邮箱配置',
      sms_setting: '短信配置'
    },
    // 基本属性
    label: {
      setting: '配置',
      app_id: 'App ID',
      app_secret: 'App 密钥',
      access_key_id: '密钥 ID',
      access_key_secret: '密钥 密码',
      android_app_key: '安卓应用 key',
      ios_app_key: 'iOS应用 key',
      android_notification_channel: '安卓通知通道',
      android_popup_activity: '安卓厂商通道打开的页面',
      api_secret: 'API 密钥',
      apns_production: 'iOS 推送产品环境',
      // 推送
      push_service: '通知内容',
      miniprogram_state: '跳转小程序类型',
      charge_started_tmpl_id: '充电开始通知模版ID',
      charge_abnormal_tmpl_id: '充电异常通知模版ID',
      charge_finish_tmpl_id: '充电结束提醒模版ID',
      charge_finish_idle_fee_tmpl_id: '充电结束占位消息模板ID',
      user_withdraw_transferred_tmp_id: '提现成功通知模板ID',
      user_withdraw_rejected_tmp_id: '提现失败通知模板ID',
      task_status_changed_tmpl_id: '工单状态通知模板ID',
      inserting_gun_charge_tmpl_id: '(公众号)即插即充模板ID',
      // 支付
      payment: '支付',
      mch_id: '商户号',
      trade_type: '交易类型',
      cert_password: '证书密码',
      cert_path: 'Api 证书',
      app_private_key: '应用私钥',
      alipay_public_key: '支付宝公钥',
      private_key: '私钥',
      public_key: '公钥',

      // 邮箱配置
      smtp_server: 'SMTP服务器',
      port: '发件端口',
      domain: '域名',
      authentication: '认证方式',
      user_name: '用户名',
      password: '密码',
      ssl: 'SSL',
      enable_starttls_auto: '启动tls',
      email_address: '邮箱地址',
      test_text: '发送测试',
      detection: '检测',

      // 短信配置
      verification_code: '验证码配置',
      pa_sms: '短信平台',
      sms_template: '验证码模板',
      withdraw_transfer_tpl_id: '提现通知模板',
      task_tpl_id: '工单状态模板',
      sms_tpl_id: '告警短信模板',
      work_order_notification_tpl_id: '工单指派模版',
      invoice_notification_tpl_id: '开票通知模版',
      sending_limit: '发送限制',
      ip_limit: '每IP 发送限制',
      account_limit: '平台发送限制',
      ip_request_interval: '请求间隔',
      account_send_limit_per_minute: '每分钟发送上限',
      ip_send_limit_per_day: '日发送上限',
      phone_number: '手机号',
      code: '验证码',
      ip_request_interval: '重发间隔',
      ip_send_limit_per_day: '每天总数',
      account_send_limit_per_minute: '每分钟上限数量',
      account_send_limit_per_day: '每天总数'
    },
    // 标题
    title: {
      edit_login: '编辑登录配置',
      miniprogram_tmpl_edit: '小程序消息模板设置',
      update_app_push: '编辑App推送配置'
    },
    miniprogram_states: {
      developer: '开发版',
      trial: '体验版',
      formal: '正式版'
    },
    push_services: {
      charging_done: '充电完成',
      close_order: '订单关闭',
      review_car_apply: '登记车型审核',
      review_group_apply: '集团申请审核',
      review_receipt_apply: '发票审核',
      review_refund_apply: '退款审核',
      withdrawal_success: '提现成功',
      withdrawal_failed: '提现失败'
    },
    // 配置名称
    setting_name: {
      // 登录配置
      app_login: 'App登录配置',
      app_wechat_login: 'App微信登录配置',
      app_weibo_login: 'App微博登录配置',
      wechat_mini_login: '微信小程序登录配置',
      alipay_mini_login: '支付宝小程序登录配置',

      // 推送配置
      app_push: 'App推送配置(阿里云)',
      wechat_push: '微信小程序订阅配置',

      // 支付配置
      app_wechat_pay: 'App微信支付配置',
      app_alipay_pay: 'App支付宝支付配置',
      app_ccb_pay: 'App建行支付配置',
      app_union_pay: 'App银联支付配置',
      wechat_mini_pay: '微信小程序支付配置',
      alipay_mini_pay: '支付宝小程序支付配置'
    },
    // 登录方式
    login_way: {
      wechat: '微信登录'
    },
    // 支付方式
    payment_type_label: '支付方式',
    payment_type: {
      wechat: '微信',
      alipay: '支付宝'
    },
    // 推送环境
    apns_productions: {
      true: '产品环境',
      false: '开发环境'
    },
    // 按钮
    button: {
      create_push: '创建推送配置',
      edit_payment: '编辑支付配置'
    }
  }
}
